var scope_0 = require('/home/runner/work/commercetools-docs/commercetools-docs/websites/sdk/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2580c2f561110aba2ebccef63439a213.js').default;
var scope_1 = require('/home/runner/work/commercetools-docs/commercetools-docs/websites/sdk/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    